<template>
  <div class="widget-attachment-preview-layout">
    <div class="widget-attachment-preview-layout__preview">
      <img
        v-if="type === 'image'"
        class="widget-attachment-preview-layout__image"
        :src="url"
        :width="width"
        :height="height"
      />
      <video
        v-else-if="type === 'video'"
        class="widget-attachment-preview-layout__video"
        controls
        :width="width"
        :style="{
          'aspect-ratio': width && height ? width / height : '16 / 9',
        }"
        @click.stop
      >
        <source :src="url" />
      </video>
    </div>

    <div class="widget-attachment-preview-layout__content">
      <widget-attachment-full-name
        class="widget-attachment-preview-layout__full-name"
        :name="name"
      />

      <div class="widget-attachment-preview-layout__details">
        ({{ sizeLabel }})
        <slot name="message-info-compensator" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import WidgetAttachmentFullName from '@widgets/shared/components/attachment/WidgetAttachmentFullName.vue'
import { getFileSizeLabel } from '@/utils/file/getFileSizeLabel'
import { computed } from '@/composition/vue/compositionApi'

const { name, size, url, width, height } = defineProps<{
  name: string // file.pdf
  size: number // in bytes
  type: 'image' | 'video'
  url: string
  width?: number
  height?: number
}>()

const sizeLabel = computed(() => getFileSizeLabel(size))
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables';

.widget-attachment-preview-layout {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: $neutral;
  font-weight: $regular-font;

  &__preview {
    flex-shrink: 0;
    flex-grow: 0;
    line-height: 0;
  }

  &__image {
    max-width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: $border-radius;
  }

  &__video {
    max-width: 100%;
    border-radius: $border-radius;
  }

  &__content {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 1;
    flex-grow: 1;
    min-width: 0;
  }

  &__full-name {
    flex-shrink: 1;
    flex-grow: 0;
    min-width: 0;
  }

  &__details {
    flex-shrink: 0;
    flex-grow: 0;
    font-size: 14px;
    line-height: 20px;
    font-weight: $medium-font;
    color: $distinct;
  }
}
</style>
